import React, { useRef, useState, useEffect } from "react";
import Hls from "hls.js";

const VideoPlayer = () => {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const url = urlParams.get('url');
    const movieTitle = urlParams.get('title');
    if (url) {
      setVideoSrc(url);
      setInputValue(url);
    }
    if (movieTitle) {
      setTitle(movieTitle);
    }
  }, []);

  useEffect(() => {
    if (Hls.isSupported() && videoSrc) {
      const hls = new Hls({
        xhrSetup: function(xhr, url) {
          xhr.withCredentials = false;
        }
      });
      const url = new URL(videoSrc);
      const queryParams = url.search;

      class CustomLoader extends Hls.DefaultConfig.loader {
        constructor(config) {
          super(config);
        }
        load(context, config, callbacks) {
          // ensure that the signature is appended to all requests.
          if (!context.url.includes("?Policy")) {
            const modifiedUrl = context.url + queryParams;
            context.url = modifiedUrl;
          }
          super.load(context, config, callbacks);
        }
      }

      hls.config.fLoader = CustomLoader;
      hls.config.pLoader = CustomLoader;

      hls.loadSource(videoSrc);
      hls.attachMedia(videoRef.current);

      return () => hls.destroy();
    }
  }, [videoSrc]);

  return (
    <div style={{ 
      minHeight: "100vh", 
      backgroundColor: "#000", 
      color: "#fff", 
      padding: "20px",
      fontFamily: "Arial, sans-serif"
    }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        {title && (
          <h1 style={{ 
            fontSize: "28px", 
            marginBottom: "20px", 
            textAlign: "center",
            color: "#fff"
          }}>
            {title}
          </h1>
        )}
        
        <div style={{ 
          backgroundColor: "#111", 
          borderRadius: "8px", 
          padding: "20px", 
          marginBottom: "20px"
        }}>
          <video 
            ref={videoRef} 
            controls 
            style={{ 
              width: "100%", 
              height: "auto",
              borderRadius: "8px",
              backgroundColor: "#000"
            }} 
          />
        </div>
        
        <div style={{ 
          backgroundColor: "#222", 
          borderRadius: "8px", 
          padding: "15px"
        }}>
          <h3 style={{ marginBottom: "10px", color: "#fff" }}>Load Custom Video</h3>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <input
              type="text"
              placeholder="Enter video URL"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              style={{
                flex: "1",
                minWidth: "300px",
                padding: "10px",
                border: "1px solid #444",
                borderRadius: "4px",
                backgroundColor: "#333",
                color: "#fff",
                fontSize: "14px"
              }}
            />
            <button
              onClick={() => setVideoSrc(inputValue)}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold"
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
              onMouseOut={(e) => e.target.style.backgroundColor = "#007bff"}
            >
              Load Video
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;

// NEW CODE #########################
// import React, { useRef, useState, useEffect } from "react";
// import Hls from "hls.js";

// const VideoPlayer = () => {
//   const videoRef = useRef(null);
//   const [videoSrc, setVideoSrc] = useState("");
//   const [inputValue, setInputValue] = useState("");
//   const [subtitleSrc, setSubtitleSrc] = useState("");
//   const [subtitleInput, setSubtitleInput] = useState("");

//   useEffect(() => {
//     if (Hls.isSupported() && videoSrc) {
//       const hls = new Hls();
//       const url = new URL(videoSrc);
//       const queryParams = url.search;

//       class CustomLoader extends Hls.DefaultConfig.loader {
//         constructor(config) {
//           super(config);
//         }
//         load(context, config, callbacks) {
//           if (!context.url.includes("?Policy")) {
//             const modifiedUrl = context.url + queryParams;
//             context.url = modifiedUrl;
//           }
//           super.load(context, config, callbacks);
//         }
//       }

//       hls.config.fLoader = CustomLoader;
//       hls.config.pLoader = CustomLoader;

//       hls.loadSource(videoSrc);
//       hls.attachMedia(videoRef.current);

//       return () => hls.destroy();
//     }
//   }, [videoSrc]);

//   // Function to fetch subtitle and create a Blob URL
//   const fetchSubtitleBlob = async (subtitleUrl) => {
//     try {
//       const response = await fetch(subtitleUrl);
//       const text = await response.text();
//       const blob = new Blob([text], { type: "text/vtt" });
//       const blobUrl = URL.createObjectURL(blob);
//       setSubtitleSrc(blobUrl);
//     } catch (error) {
//       console.error("Error fetching subtitle file:", error);
//     }
//   };

//   return (
//     <div className="p-4">
//       <input
//         type="text"
//         className="border p-2 w-full mb-2"
//         placeholder="Enter CloudFront Signed URL"
//         value={inputValue}
//         onChange={(e) => setInputValue(e.target.value)}
//       />
//       <button
//         className="bg-blue-500 text-white px-4 py-2 mb-4"
//         onClick={() => setVideoSrc(inputValue)}
//       >
//         Load Video
//       </button>
//       <input
//         type="text"
//         className="border p-2 w-full mb-2"
//         placeholder="Enter Subtitle S3 URL (.vtt format)"
//         value={subtitleInput}
//         onChange={(e) => setSubtitleInput(e.target.value)}
//       />
//       <button
//         className="bg-green-500 text-white px-4 py-2 mb-4"
//         onClick={() => fetchSubtitleBlob(subtitleInput)}
//       >
//         Load Subtitles
//       </button>
//       <video ref={videoRef} controls style={{ width: "500px" }}>
//         {subtitleSrc && (
//           <track
//             kind="subtitles"
//             label="Subtitles"
//             srclang="en"
//             src={subtitleSrc}
//             default
//           />
//         )}
//       </video>
//     </div>
//   );
// };

// export default VideoPlayer;
